(()=>{
  const form=document.querySelector("#km-calculator .kmcalc-form");
  if(!form)return;

  const pickup=document.getElementById("pickup-date");
  const ret=document.getElementById("return-date");
  const kmInput=document.getElementById("km-input");
  const totalEl=document.getElementById("km-total");
  const daysEl=document.getElementById("rental-days");
  const typeSelect=document.getElementById("vehicle-type-pref");
  const waButton=document.getElementById("km-wa-btn");
  const calcButton=document.getElementById("km-calc-btn");
  const status=document.getElementById("km-status");
  const step1=form.querySelector('.guided-step[data-step="1"]');
  const step5=form.querySelector('.guided-step[data-step="5"]');
  const sticky=form.querySelector(".sticky-vehicle-summary");
  const finalSummary=form.querySelector(".final-rental-summary");
  if(!pickup||!ret||!step1)return;

  const WHATSAPP_NUMBER="393318538663";
  const SLOTS=["08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30"];
  const RATES={1:60,2:60,3:60,4:60,5:60,6:60,7:80,8:60,9:60,10:60,12:60,13:60,14:60,15:80,16:60,17:60,18:60,19:60};
  const track=(name,params={})=>{if(typeof window.gtag==="function")window.gtag("event",name,params);};
  const numberFromSrc=src=>{const m=String(src||"").match(/flotta-(\d{2})\.jpg/i);return m?Number(m[1]):null;};
  const fmtDate=value=>{if(!value)return"—";const [y,m,d]=value.split("-");return `${d}/${m}/${y}`;};

  if(!document.getElementById("hours-alternatives-styles")){
    const style=document.createElement("style");
    style.id="hours-alternatives-styles";
    style.textContent=`
      .rental-time-fields{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-top:10px}
      .rental-time-field label{display:block;font-size:13px;font-weight:900;margin-bottom:8px}
      .rental-time-field select{box-sizing:border-box;width:100%;min-height:54px;border:1px solid #cfd4d6;border-radius:14px;padding:0 15px;font:inherit;font-size:16px;font-weight:800;outline:none;background:#fff;color:#111}
      .rental-time-field select:focus{border-color:#111}
      .rental-time-help{grid-column:1/3;font-size:11px;color:#71797c;line-height:1.4;margin:0 2px 2px}
      .hours-disabled{opacity:.48!important;cursor:not-allowed!important;filter:grayscale(.25)}
      .rental-alternatives{display:none;margin:12px 0 14px;border:1px solid #efc4c4;border-radius:18px;padding:15px;background:#fff7f7}
      .rental-alternatives.show{display:block}
      .rental-alternatives h4{margin:0 0 4px;font-size:16px;line-height:1.25}
      .rental-alternatives>p{margin:0 0 12px;font-size:12px;color:#656d70;line-height:1.4}
      .alternative-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:9px}
      .alternative-card{overflow:hidden;border:1px solid #dfe2e3;border-radius:14px;background:#fff}
      .alternative-card img{display:block;width:100%;aspect-ratio:4/3;object-fit:cover;background:#eee}
      .alternative-body{padding:10px}
      .alternative-body b{display:block;font-size:14px}.alternative-body small{display:block;font-size:10px;color:#687174;margin:3px 0 8px;line-height:1.35}
      .alternative-select{width:100%;min-height:38px;border:0;border-radius:10px;background:#111;color:#fff;font:inherit;font-size:10px;font-weight:950;cursor:pointer}
      .alternative-available{display:inline-flex;margin-bottom:7px;border-radius:999px;padding:4px 7px;background:#e5f8eb;color:#117536;font-size:8px;font-weight:950;text-transform:uppercase;letter-spacing:.04em}
      @media(max-width:720px){.rental-time-fields{grid-template-columns:1fr}.rental-time-help{grid-column:1}.alternative-grid{grid-template-columns:1fr}.alternative-card{display:grid;grid-template-columns:108px 1fr}.alternative-card img{width:108px;height:100%;min-height:108px;aspect-ratio:auto}.alternative-body{padding:10px 11px}}
    `;
    document.head.appendChild(style);
  }

  const headSmall=step1.querySelector(".guided-step-head small");
  if(headSmall)headSmall.textContent="Data e ora di ritiro e riconsegna";

  const timeWrap=document.createElement("div");
  timeWrap.className="rental-time-fields";
  const makeOptions=()=>`<option value="">Seleziona orario</option>${SLOTS.map(t=>`<option value="${t}">${t}</option>`).join("")}`;
  timeWrap.innerHTML=`
    <div class="rental-time-field"><label for="pickup-time">Ora di ritiro</label><select id="pickup-time" aria-label="Ora di ritiro">${makeOptions()}</select></div>
    <div class="rental-time-field"><label for="return-time">Ora di riconsegna</label><select id="return-time" aria-label="Ora di riconsegna">${makeOptions()}</select></div>
    <p class="rental-time-help">Orari selezionabili in sede: 8:30–12:00 e 14:00–18:30.</p>`;
  const dateGrid=pickup.closest(".kmcalc-fields")||ret.closest(".kmcalc-fields");
  if(dateGrid)dateGrid.insertAdjacentElement("afterend",timeWrap);else step1.appendChild(timeWrap);
  const pickupTime=document.getElementById("pickup-time");
  const returnTime=document.getElementById("return-time");

  const sameDay=()=>pickup.value&&ret.value&&pickup.value===ret.value;
  const syncReturnTimeOptions=()=>{
    [...returnTime.options].forEach(opt=>{
      if(!opt.value){opt.disabled=false;return;}
      opt.disabled=!!(sameDay()&&pickupTime.value&&opt.value<pickupTime.value);
    });
    if(returnTime.value&&returnTime.selectedOptions[0]?.disabled)returnTime.value="";
  };

  const dateInfo=()=>{
    if(!pickup.value||!ret.value)return null;
    const [sy,sm,sd]=pickup.value.split("-").map(Number),[ey,em,ed]=ret.value.split("-").map(Number);
    const start=Date.UTC(sy,sm-1,sd),end=Date.UTC(ey,em-1,ed);
    if(!Number.isFinite(start)||!Number.isFinite(end)||end<start)return null;
    return {days:Math.floor((end-start)/86400000)+1,pickup:pickup.value,ret:ret.value};
  };
  const currentVehicle=()=>{
    const title=document.querySelector(".vehicle-picker-title")?.textContent||"";
    const m=title.match(/N\.?\s*(\d+)/i);if(!m)return null;
    const n=Number(m[1]);
    const img=document.querySelector(".vehicle-preview.show img")?.src||document.querySelector(`.vehicle-option img[alt="Furgone N.${n}"]`)?.src||"";
    return {n,rate:RATES[n]||null,img};
  };
  const kmValue=()=>{const v=Math.ceil(Number(kmInput?.value));return Number.isFinite(v)&&v>0?v:null;};
  const totalValue=()=>{const v=(totalEl?.textContent||"").trim();return v&&v!=="—"?v:null;};
  const completeTimes=()=>!!(pickupTime.value&&returnTime.value);

  const vehicleCatalog=()=>{
    const out=[];
    document.querySelectorAll(".vehicle-option").forEach(option=>{
      const img=option.querySelector("img");const n=numberFromSrc(img?.src);if(!n)return;
      out.push({n,rate:RATES[n]||null,img:img.src,option});
    });
    return out.sort((a,b)=>a.n-b.n);
  };

  const availability=new Map();
  const previousSetAvailability=window.MASSAGOMME_SET_AVAILABILITY;
  let lastAlternativesTrackKey="";

  const alternatives=document.createElement("div");
  alternatives.className="rental-alternatives";
  alternatives.innerHTML=`<h4>Il mezzo scelto non è disponibile</h4><p>Per le stesse date e orari puoi scegliere subito uno di questi furgoni disponibili.</p><div class="alternative-grid"></div>`;
  if(finalSummary)finalSummary.insertAdjacentElement("afterend",alternatives);else if(step5)step5.insertBefore(alternatives,waButton||null);
  const alternativeGrid=alternatives.querySelector(".alternative-grid");

  const normalizeAvailability=map=>{
    availability.clear();
    if(!map||typeof map!=="object")return;
    Object.entries(map).forEach(([key,value])=>{
      const n=Number(key);if(n<1||n>19)return;
      const state=value===true||value==="available"?true:value===false||value==="unavailable"?false:null;
      availability.set(n,state);
    });
  };

  const chooseAlternative=vehicle=>{
    if(typeSelect&&vehicle.option.style.display==="none"){
      typeSelect.value="";
      typeSelect.dispatchEvent(new Event("change",{bubbles:true}));
    }
    track("alternativa_furgone_selezionata",{furgone_numero:vehicle.n,tariffa:vehicle.rate});
    vehicle.option.click();
    setTimeout(()=>{
      updateAll();
      if(dateInfo()&&kmValue()&&completeTimes())calcButton?.click();
    },100);
  };

  const renderAlternatives=()=>{
    const selected=currentVehicle();
    if(!selected||availability.get(selected.n)!==false){alternatives.classList.remove("show");alternativeGrid.innerHTML="";return;}
    const choices=vehicleCatalog().filter(v=>v.n!==selected.n&&availability.get(v.n)===true)
      .sort((a,b)=>((a.rate===selected.rate?0:1)-(b.rate===selected.rate?0:1))||a.n-b.n).slice(0,3);
    if(!choices.length){alternatives.classList.remove("show");alternativeGrid.innerHTML="";return;}
    alternativeGrid.innerHTML="";
    choices.forEach(v=>{
      const card=document.createElement("article");card.className="alternative-card";
      card.innerHTML=`<img src="${v.img}" alt="Furgone N.${v.n}" loading="lazy"><div class="alternative-body"><span class="alternative-available">Disponibile</span><b>Furgone N.${v.n} · ${v.rate} €/giorno</b><small>150 km inclusi al giorno · foto reale del mezzo</small><button type="button" class="alternative-select">SCEGLI QUESTO MEZZO</button></div>`;
      card.querySelector("button").addEventListener("click",()=>chooseAlternative(v));alternativeGrid.appendChild(card);
    });
    alternatives.classList.add("show");
    const info=dateInfo();
    const key=`${selected.n}|${info?.pickup||""}|${pickupTime.value}|${info?.ret||""}|${returnTime.value}|${choices.map(v=>v.n).join(",")}`;
    if(key!==lastAlternativesTrackKey){lastAlternativesTrackKey=key;track("alternative_furgone_mostrate",{furgone_numero:selected.n,alternative:choices.length});}
  };

  window.MASSAGOMME_SET_AVAILABILITY=map=>{
    normalizeAvailability(map);
    if(typeof previousSetAvailability==="function")previousSetAvailability(map);
    setTimeout(()=>{renderAlternatives();updateAll();},0);
  };

  const requestAvailabilityWithTimes=async()=>{
    const info=dateInfo();
    if(!info||!completeTimes())return;
    const detail={pickup:info.pickup,pickupTime:pickupTime.value,returnDate:info.ret,returnTime:returnTime.value};
    document.dispatchEvent(new CustomEvent("massagomme:availability:request",{detail}));
    if(typeof window.MASSAGOMME_RENTHUB_CHECK==="function"){
      try{
        const map=await window.MASSAGOMME_RENTHUB_CHECK(detail);
        if(map&&typeof map==="object")window.MASSAGOMME_SET_AVAILABILITY(map);
      }catch(e){console.warn("RentHub availability check unavailable",e);}
    }
  };

  const updateSummaries=()=>{
    const v=currentVehicle(),info=dateInfo();
    if(daysEl&&info)daysEl.textContent=`${info.days} ${info.days===1?"giorno":"giorni"} di noleggio · 150 km inclusi al giorno`;
    const timeRange=info&&completeTimes()?`${fmtDate(info.pickup)} ore ${pickupTime.value} → ${fmtDate(info.ret)} ore ${returnTime.value}`:null;
    if(sticky?.classList.contains("show")){
      const small=sticky.querySelector("small");
      if(small&&info)small.textContent=timeRange?`${timeRange} · ${info.days} ${info.days===1?"giorno":"giorni"}`:`${fmtDate(info.pickup)} → ${fmtDate(info.ret)} · seleziona gli orari`;
    }
    if(finalSummary?.classList.contains("show")&&v&&info){
      const sub=finalSummary.querySelector(".final-sub");
      if(sub)sub.textContent=`${timeRange||`${fmtDate(info.pickup)} → ${fmtDate(info.ret)} · orari da selezionare`} · ${v.rate} € / giorno · 150 km inclusi al giorno`;
    }
  };

  const setWhatsappState=()=>{
    if(!waButton)return;
    const quoteReady=!!(currentVehicle()&&dateInfo()&&kmValue()&&totalValue());
    const enabled=quoteReady&&completeTimes();
    waButton.classList.toggle("hours-disabled",quoteReady&&!enabled);
    waButton.setAttribute("aria-disabled",enabled?"false":"true");
    if(quoteReady&&!completeTimes()&&status)status.textContent="Seleziona ora di ritiro e riconsegna per verificare la disponibilità.";
  };

  const rewriteWhatsapp=()=>{
    if(!waButton)return;
    const v=currentVehicle(),info=dateInfo(),km=kmValue(),total=totalValue();
    if(!v||!info||!km||!total||!completeTimes()){setWhatsappState();return;}
    const typeLine=typeSelect?.value?`\nTipologia preferita: ${typeSelect.value}`:"";
    const message=`Ciao, ti contatto dal sito www.massagomme.com. Vorrei verificare la disponibilità di un furgone senza conducente per queste date e orari:\n\nRitiro: ${fmtDate(info.pickup)} ore ${pickupTime.value}\nRiconsegna: ${fmtDate(info.ret)} ore ${returnTime.value}\nGiorni: ${info.days}${typeLine}\nFurgone scelto: N.${v.n}\nTariffa del mezzo: ${v.rate} € / giorno\nKm totali previsti: ${km}\nPreventivo indicativo: ${total}\nFoto del mezzo: ${v.img}\n\nPotete confermarmi la disponibilità per queste date e orari?`;
    waButton.href=`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
    waButton.classList.remove("hours-disabled");waButton.setAttribute("aria-disabled","false");
  };

  const updateAll=()=>{syncReturnTimeOptions();updateSummaries();setWhatsappState();rewriteWhatsapp();renderAlternatives();};

  pickupTime.addEventListener("change",()=>{
    syncReturnTimeOptions();track("orario_ritiro_selezionato",{orario:pickupTime.value||"non_selezionato"});
    updateAll();requestAvailabilityWithTimes();
  });
  returnTime.addEventListener("change",()=>{
    track("orario_riconsegna_selezionato",{orario:returnTime.value||"non_selezionato"});
    updateAll();requestAvailabilityWithTimes();
  });
  pickup.addEventListener("change",()=>{syncReturnTimeOptions();updateAll();if(completeTimes())requestAvailabilityWithTimes();});
  ret.addEventListener("change",()=>{syncReturnTimeOptions();updateAll();if(completeTimes())requestAvailabilityWithTimes();});

  waButton?.addEventListener("click",e=>{
    if(!completeTimes()){
      e.preventDefault();e.stopImmediatePropagation();
      if(status)status.textContent="Prima seleziona sia l'ora di ritiro sia l'ora di riconsegna.";
      pickupTime.focus();return;
    }
    rewriteWhatsapp();
  },true);
  calcButton?.addEventListener("click",()=>setTimeout(()=>{updateAll();rewriteWhatsapp();},90));
  document.querySelectorAll(".vehicle-option").forEach(option=>option.addEventListener("click",()=>setTimeout(updateAll,30)));

  const observer=new MutationObserver(()=>setTimeout(updateAll,0));
  if(totalEl)observer.observe(totalEl,{childList:true,subtree:true,characterData:true});
  const pickerTitle=document.querySelector(".vehicle-picker-title");if(pickerTitle)observer.observe(pickerTitle,{childList:true,subtree:true,characterData:true});

  updateAll();
})();
